import { Link } from "react-router-dom";
import { Terminal, Github, Twitter, Linkedin } from "lucide-react";

export const Footer = () => {
  return (
    <footer className="border-t border-border/40 bg-card/50" data-testid="footer">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* Brand */}
          <div className="col-span-1 md:col-span-2">
            <Link to="/" className="flex items-center gap-2 mb-4">
              <Terminal className="h-6 w-6 text-primary" />
              <span className="font-heading font-bold text-lg">
                DevOps<span className="text-primary">Learn</span>
              </span>
            </Link>
            <p className="text-muted-foreground text-sm max-w-md mb-4">
              Maîtrisez le Cloud et DevOps avec des cours vidéo et des laboratoires interactifs. 
              Docker, Kubernetes, AWS, Terraform et plus encore.
            </p>
            <div className="flex gap-4">
              <a href="#" className="text-muted-foreground hover:text-primary transition-colors">
                <Github className="w-5 h-5" />
              </a>
              <a href="#" className="text-muted-foreground hover:text-primary transition-colors">
                <Twitter className="w-5 h-5" />
              </a>
              <a href="#" className="text-muted-foreground hover:text-primary transition-colors">
                <Linkedin className="w-5 h-5" />
              </a>
            </div>
          </div>

          {/* Links */}
          <div>
            <h4 className="font-heading font-bold text-sm uppercase tracking-widest text-muted-foreground mb-4">
              Plateforme
            </h4>
            <ul className="space-y-2">
              <li>
                <Link to="/courses" className="text-sm text-muted-foreground hover:text-foreground transition-colors">
                  Tous les cours
                </Link>
              </li>
              <li>
                <Link to="/pricing" className="text-sm text-muted-foreground hover:text-foreground transition-colors">
                  Tarifs
                </Link>
              </li>
              <li>
                <Link to="/auth" className="text-sm text-muted-foreground hover:text-foreground transition-colors">
                  Devenir instructeur
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="font-heading font-bold text-sm uppercase tracking-widest text-muted-foreground mb-4">
              Technologies
            </h4>
            <ul className="space-y-2">
              <li>
                <Link to="/courses?category=docker" className="text-sm text-muted-foreground hover:text-foreground transition-colors">
                  Docker
                </Link>
              </li>
              <li>
                <Link to="/courses?category=kubernetes" className="text-sm text-muted-foreground hover:text-foreground transition-colors">
                  Kubernetes
                </Link>
              </li>
              <li>
                <Link to="/courses?category=aws" className="text-sm text-muted-foreground hover:text-foreground transition-colors">
                  AWS
                </Link>
              </li>
              <li>
                <Link to="/courses?category=devops" className="text-sm text-muted-foreground hover:text-foreground transition-colors">
                  CI/CD
                </Link>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-12 pt-8 border-t border-border/40">
          <p className="text-center text-sm text-muted-foreground">
            © {new Date().getFullYear()} DevOpsLearn. Tous droits réservés.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
